import { call, put, takeLatest } from "redux-saga/effects";
import { setIsLoading } from "../../Containers/App/action";
import { signUp } from "../../Domain/api";
import { setRegisterError } from "./action";
import { REGISTER } from "./constants";

export function* doRegister({data, cbSuccess}){
    try {
        yield put(setIsLoading(true));
        yield call(signUp, data);
        yield put(setIsLoading(false));
        cbSuccess && cbSuccess();
    } catch (error) {
        yield put(setIsLoading(false));
        yield put(setRegisterError(error.response.data.message))
    }
}
export default function* register() {
    yield takeLatest(REGISTER, doRegister);
}